import React from "react";
import MainMenuMixin from "../ui_elements/main-menu-mixin";
import Dispatcher from "../../dispatcher";
import { ltiLaunch } from "../../../fraction/ui/utils/location";

var ManageResources = require("../resources/manage-resources");

class AppMenu extends React.Component {
  constructor() {
    super();
    this.state = {};

    this._isHeader = this._isHeader.bind(this);
    this._isMainMenu = this._isMainMenu.bind(this);
    this._isSettingsMenu = this._isSettingsMenu.bind(this);
    this._closeMenu = this._closeMenu.bind(this);
    this._libraryButton = this._libraryButton.bind(this);
    this._clickBookshelf = this._clickBookshelf.bind(this);
    this._clickUserInfo = this._clickUserInfo.bind(this);
    this._clickSupport = this._clickSupport.bind(this);
    this._clickAppMenuElement = this._clickAppMenuElement.bind(this);
    this._clickStore = this._clickStore.bind(this);
    this._clickResources = this._clickResources.bind(this);
    this._clickDevices = this._clickDevices.bind(this);
    this._clickPOD = this._clickPOD.bind(this);
    this._clickAbout = this._clickAbout.bind(this);
    this._clickPrivacy = this._clickPrivacy.bind(this);
    this._clickTerms = this._clickTerms.bind(this);
    this._clickOptOut = this._clickOptOut.bind(this);
    this._clickScoreCenter = this._clickScoreCenter.bind(this);
    this._clickSharing = this._clickSharing.bind(this);
    this._clickHighlighters = this._clickHighlighters.bind(this);
    this._updateLicense = this._updateLicense.bind(this);
    this._redeem = this._redeem.bind(this);
    this._logOut = this._logOut.bind(this);
    this._facultyUpload = this._facultyUpload.bind(this);
    this._completeAccount = this._completeAccount.bind(this);
    this._downloadApp = this._downloadApp.bind(this);
    this._downloadAppModal = this._downloadAppModal.bind(this);
    this._launchInApp = this._launchInApp.bind(this);
    this._takeSurvey = this._takeSurvey.bind(this);
    this._clickVstAnalytics = this._clickVstAnalytics.bind(this);
    this._clickNoticeCollection = this._clickNoticeCollection.bind(this);
  }

  _isHeader() {
    return this.state.env === "header";
  }

  _isMainMenu() {
    return this.state.env === "main-menu";
  }

  _isSettingsMenu() {
    return this.state.env === "settings-menu";
  }

  _closeMenu(e) {
    if (this._isHeader()) {
      Dispatcher.emit(Dispatcher.CLOSE_MENU);
    } else if (this._isMainMenu()) {
      // Main Menu
      MainMenuMixin._menuClose(e);
    }
  }

  _libraryButton(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Router.setRoute("/");
    Fraction.Reporter.gaEvent(`${this.state.env}/library-button-or-logo`);
  }

  _clickBookshelf(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Reporter.gaEvent(`${this.state.env}/bookshelf`);

    // If brand defines URL for bookshelf click, go there and then exit function
    if (Fraction.Brand.Bookshelf.url) {
      Fraction.Helpers.Locations.safeRedirect(
        Fraction.Brand.Bookshelf.url,
        Fraction.Brand.Bookshelf.newTab ? "_blank" : false
      );
      return;
    }

    // If no brand url is defined, reload route
    if (Fraction.Router.getRoute().join().length === 0) {
      window.location.reload();
    } else {
      Fraction.Router.setRoute("/");
    }
  }

  _clickUserInfo(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.ssoToOldOnlineURL(
      Fraction.Brand.Locations.AccountCenter,
      true
    );
    Fraction.Reporter.gaEvent(`${this.state.env}/user-info`);
  }

  _clickSupport(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.Locations.safeRedirect(
      Fraction.Brand.Support.url,
      "_blank"
    );
    Fraction.Reporter.gaEvent(`${this.state.env}/support`);
  }

  _clickAppMenuElement(e, element) {
    this._closeMenu(e);
    e.preventDefault();
    if (element.lti && Fraction.User.contextTokens) {
      ltiLaunch(Fraction.User, element.lti.type, element.newTab, false, {
        label: element.label
      });
    } else if (element.sso) {
      Fraction.Helpers.Locations.ssoToOldOnlineURL(element.url, element.newTab);
    } else {
      Fraction.Helpers.Locations.safeRedirect(
        element.url,
        element.newTab ? "_blank" : false
      );
    }
    Fraction.Reporter.gaEvent(
      `${this.state.env}/${element.key || element.label}`
    );
  }

  _clickStore(e) {
    this._closeMenu(e);
    e.preventDefault();
    if (Fraction.Brand.Store.sso) {
      Fraction.Helpers.ssoToOldOnlineURL(Fraction.Brand.Store.url, true);
    } else {
      Fraction.Helpers.Locations.safeRedirect(
        Fraction.Brand.Store.url,
        "_blank"
      );
    }
    Fraction.Reporter.gaEvent(`${this.state.env}/store`);
  }

  _clickResources(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.ssoToOldOnlineURL(
      Fraction.Brand.Locations.Resources,
      true
    );
    Fraction.Reporter.gaEvent(`${this.state.env}/resources`);
  }

  _clickDevices(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.ssoToOldOnlineURL(Fraction.Brand.Locations.Devices, true);
    Fraction.Reporter.gaEvent(`${this.state.env}/devices`);
  }

  _clickPOD(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.Locations.safeRedirect("/#/print-on-demand", "_blank");
    Fraction.Reporter.gaEvent(`${this.state.env}/pod`);
  }

  _clickAbout(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.Locations.safeRedirect(
      Fraction.Brand.Locations.about,
      "_blank"
    );
    Fraction.Reporter.gaEvent(`${this.state.env}/about`);
  }

  _clickPrivacy(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.Locations.safeRedirect(
      Fraction.Brand.Privacy.url || i18n.t("locations.zendesk-privacy"),
      "_blank"
    );
    Fraction.Reporter.gaEvent(`${this.state.env}/privacy`);
  }

  _clickNoticeCollection(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.Locations.safeRedirect(
      i18n.t("locations.zendesk-notice-collection"),
      "_blank"
    );
    Fraction.Reporter.gaEvent(`${this.state.env}/notice-collection`);
  }

  _clickTerms(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.Locations.safeRedirect(
      Fraction.Brand.Terms.url || i18n.t("locations.zendesk-tou"),
      "_blank"
    );
    Fraction.Reporter.gaEvent(`${this.state.env}/terms`);
  }

  _clickOptOut(e) {
    this._closeMenu(e);
    e.preventDefault();
    const url = Fraction.Helpers.buildOptOutUrl();
    Fraction.Helpers.ssoToOldOnlineURL(url, true);
    Fraction.Reporter.gaEvent(`${this.state.env}/opt_out`);
  }

  _clickScoreCenter(e) {
    this._closeMenu(e);
    e.preventDefault();
    const url = Fraction.Helpers.buildScoreCentertUrl();
    Fraction.Helpers.ssoToOldOnlineURL(url, true);
    Fraction.Reporter.gaEvent(`${this.state.env}/score_center`);
  }

  _clickSharing(e) {
    this._closeMenu(e);
    if (this._isMainMenu()) {
      // different focus elements
      ManageResources._manageSharing(
        e,
        $(".menu-button:visible"),
        this.props.isbn
      );
    } else if (this._isHeader()) {
      ManageResources._manageSharing(e, $("#tools-button"), this.props.isbn);
    } else if (this._isSettingsMenu()) {
      ManageResources._manageSharing(e, $("#settings-button"), this.props.isbn);
    }
    Fraction.Reporter.gaEvent(`${this.state.env}/manage-sharing`);
  }

  _clickHighlighters(e) {
    this._closeMenu(e); // header doesn't actually close here
    e.preventDefault();
    Dispatcher.emit(Dispatcher.OPEN_MODAL, "manage-highlighters");
    Fraction.Reporter.gaEvent(`${this.state.env}/manage-highlighters`);
  }

  _updateLicense(e) {
    this._closeMenu(e);
    Fraction.Helpers.userUpdateLicense();
    Fraction.Reporter.gaEvent(`${this.state.env}/update-license`);
    if (this._isMainMenu()) {
      // different focus elements
      document.querySelector(".menu-button").focus();
    } else if (this._isHeader()) {
      document.getElementById("tools-button").focus();
    } else if (this._isSettingsMenu()) {
      document.getElementById("settings-button").focus();
    }
  }

  _redeem(e) {
    this._closeMenu(e); // header doesn't actually close here
    e.preventDefault();
    Dispatcher.emit(Dispatcher.OPEN_MODAL, "redeem-code");
    Fraction.Reporter.gaEvent(`${this.state.env}/redeem-modal`);
  }

  _logOut(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.signUserOut();
    Fraction.Reporter.gaEvent(`${this.state.env}/logout`);
  }

  _facultyUpload(e) {
    this._closeMenu(e);
    e.preventDefault();
    const content = (
      <div id="faculty-upload-container">
        <div id="faculty-upload-top">
          <p id="upload-tos">{i18n.t("main-menu.faculty.upload-tos")}</p>
        </div>
        <div id="faculty-upload-bottom">
          <p id="sales-pitch">{i18n.t("main-menu.faculty.sales-pitch")}</p>
          <p id="process">
            {i18n.t("main-menu.faculty.process")}{" "}
            <span className="bold">
              {i18n.t("main-menu.faculty.required-info")}
            </span>
          </p>
        </div>
        <div className="button-wrapper">
          <button
            className="cancel"
            onClick={() => Fraction.Helpers.removeVSTModal()}
          >
            {i18n.t("base.cancel")}
          </button>
          <a
            className="submit"
            href="mailto:publisherops@vitalsource.com?subject=Add my OER content to Bookshelf!"
          >
            {i18n.t("sso.finish-account")}
          </a>
        </div>
      </div>
    );

    Fraction.Helpers.showVSTModal(
      {
        menuId: "faculty-upload",
        title: "Faculty Upload",
        content: content,
        closeCallback: () => {},
        modalContainerHeader: true,
        definingClass: "faculty-upload",
        modalDimensions: "hugeModal"
      },
      e.currentTarget
    );
    Fraction.Reporter.gaEvent("header/faculty-upload");
  }

  _completeAccount(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Reporter.gaEvent(`${this.state.env}/complete-account`);
    Fraction.Helpers.saveUserData("ssoTimeout", Date.now());
    Fraction.Helpers.storeAndRedirect("/user/sso");
  }

  _downloadApp(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.downloadApp();
    Fraction.Helpers.removeModal(); // why remove modal from header instead of menu close?
    Fraction.Reporter.gaEvent(
      `V3/${this.state.env}/read-offline`,
      "",
      "downloadAppFromMenu"
    );
  }

  _downloadAppModal(e) {
    this._closeMenu(e);
    e.preventDefault();
    if (Fraction.User.ssoOnly) {
      Fraction.Helpers.showModal(
        {
          title: (
            <span className="offScreen">
              {i18n.t("main-menu.download-app")}
            </span>
          ),
          content: (
            <div>
              {i18n.t("main-menu.ref-download-app")}
              <a href="#" onClick={this._downloadApp} target="_blank">
                {i18n.t("main-menu.got-it")}
              </a>
            </div>
          ),
          closeCallback: () => {},
          definingClass: "app-modal",
          className: "download-app-modal",
          hideCloseButton: true,
          buttons: []
        },
        $(e.currentTarget)
      );
    } else {
      Fraction.Helpers.downloadApp();
    }
  }

  _launchInApp(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Helpers.launchInApp(this.props.isbn, true);
  }

  _takeSurvey(e) {
    this._closeMenu(e);
    e.preventDefault();
    Fraction.Reporter.generalFeedback(true);
    Fraction.Reporter.gaEvent(`${this.state.env}/take-survey`);
  }

  _clickVstAnalytics(e) {
    if (Fraction.User.contextTokens) {
      ltiLaunch(Fraction.User, "vst_analytics", true, false, {
        label: i18n.t("global-bar.vst-analytics")
      });
      Fraction.Reporter.gaEvent(`${this.state.env}/vst-analytics`);
    }
  }

  shouldShowReadOffline() {
    return Fraction.Helpers.ReadOffline.shouldReadOffline();
  }

  shouldShowUserInfo() {
    return (
      Fraction.Brand.Menu.user_info &&
      Fraction.Helpers.Users.isFullAccountUser()
    );
  }

  shouldShowDevices() {
    return Fraction.Brand.Menu.devices;
  }

  shouldShowPOD() {
    return Fraction.Brand.Menu.pod && Fraction.User.hasPrintOnDemand;
  }

  shouldShowResources() {
    return Fraction.Brand.Menu.resources && Fraction.User.hasAncillaries;
  }

  shouldShowAbout() {
    return Fraction.Brand.Menu.about;
  }

  shouldShowOptOut() {
    return Fraction.Brand.OptOut.enabled;
  }

  shouldShowLibrary() {
    return Fraction.Brand.Library.visible && Fraction.Brand.Bookshelf.visible;
  }

  shouldShowPrivacy() {
    return Fraction.Brand.Privacy.enabled;
  }

  shouldShowNoticeCollection() {
    return Fraction.Brand.Menu.notice_collection;
  }

  shouldShowTerms() {
    return Fraction.Brand.Terms.enabled;
  }

  shouldShowLogout() {
    return Fraction.Brand.Menu.sign_out;
  }

  shouldShowFeedback() {
    return Fraction.Brand.Feedback.enabled;
  }

  shouldShowStore() {
    return Fraction.Brand.Store.enabled;
  }

  shouldShowSupport() {
    return Fraction.Brand.Support.enabled;
  }

  shouldShowScoreCenter() {
    return Fraction.Brand.ScoreCenter.enabled;
  }

  shouldShowRedeem() {
    return Fraction.Brand.Menu.redeem;
  }

  shouldShowUpdateLicense() {
    return Fraction.Brand.Menu.update_license;
  }

  shouldShowFacultyUpload() {
    return (
      Fraction.Brand.Menu.faculty_upload && Fraction.Helpers.isInstructor()
    );
  }

  shouldShowSharing() {
    return Fraction.Brand.Menu.sharing && Fraction.Brand.Sharing.enabled;
  }

  shouldShowCompleteAccount() {
    return (
      Fraction.Helpers.Users.isReferenceUser() &&
      !Fraction.Brand.AccountCompletion.ssoOnly
    );
  }

  shouldShowHighlighters() {
    return Fraction.Brand.Menu.highlighters;
  }

  shouldShowVstAnalytics() {
    return (
      Fraction.User &&
      Fraction.Brand.VstAnalytics.enabled &&
      Fraction.User.redirectData &&
      Fraction.User.redirectData.role === "instructor"
    );
  }

  render() {
    return <div>whoops, looks like you didn't override me</div>;
  }
}

export default { Component: AppMenu };

// prop types
// env = main-menu || header
